@if (showLogin()) {
  <div class="tw:relative tw:flex tw:justify-center tw:items-center tw:min-h-screen tw:h-screen">
    <!-- Start: BACKROUND GRID AND COLOR -->
    <div
      class="tw:dark:opacity-20 tw:absolute tw:inset-0 tw:z-0 tw:bg-[linear-gradient(to_right,var(--p-content-border-color)_1px,transparent_1px),linear-gradient(to_bottom,var(--p-content-border-color)_1px,transparent_1px)] tw:bg-[length:10rem_10rem] tw:[mask-image:radial-gradient(ellipse_120%_100%_at_50%_0%,black_0%,black_25%,transparent_80%)] tw:[mask-size:100%_100%] tw:[mask-repeat:no-repeat] tw:[-webkit-mask-image:radial-gradient(ellipse_120%_100%_at_50%_0%,black_0%,black_25%,transparent_80%)] tw:[-webkit-mask-size:100%_100%] tw:[-webkit-mask-repeat:no-repeat]"></div>
    <div
      class="tw:absolute tw:inset-x-0 tw:top-0 tw:z-0 tw:min-h-[100%] tw:-translate-y-1/4 tw:transform-gpu tw:overflow-hidden tw:blur-3xl"
      aria-hidden="true">
      <div
        class="tw:absolute tw:left-[calc(50%-11rem)] tw:top-0 tw:aspect-[1155/678] tw:w-[36.125rem] tw:-translate-x-1/2 tw:rotate-[30deg] tw:bg-gradient-to-tr tw:from-pink-500/40 tw:to-violet-500/40 tw:opacity-30 tw:pointer-events-none tw:sm:left-[calc(50%-30rem)] tw:sm:w-[72.1875rem]"
        style="
          clip-path: polygon(
            74.1% 44.1%,
            100% 61.6%,
            97.5% 26.9%,
            85.5% 0.1%,
            80.7% 2%,
            72.5% 32.5%,
            60.2% 62.4%,
            52.4% 68.1%,
            47.5% 58.3%,
            45.2% 34.5%,
            27.5% 76.7%,
            0.1% 64.9%,
            17.9% 100%,
            27.6% 76.8%,
            76.1% 97.7%,
            74.1% 44.1%
          );
        "></div>
    </div>
    <!-- End: BACKROUND GRID AND COLOR -->

    <div
      class="card tw:flex tw:max-w-full tw:justify-center tw:gap-4 tw:items-center tw:relative tw:z-10 tw:rounded-2xl tw:p-4 tw:shadow tw:border tw:border-surface">
      <!-- Info Section -->
      <div
        class="tw:hidden tw:md:flex tw:max-w-3xl tw:w-full tw:flex-col tw:gap-14 tw:bg-emphasis tw:p-12 tw:rounded-2xl">
        <div class="tw:w-[12rem] tw:ps-2">
          <img
            [src]="
              themeService.isDark()
                ? 'assets/images/brand/logo-light.svg'
                : 'assets/images/brand/logo-dark.svg'
            "
            [alt]="appConfig().name || 'GenGuardX'" />
        </div>

        <p-timeline
          [value]="info"
          p-timeline-event-opposite="hidden"
          class="tw:w-full">
          <ng-template
            pTemplate="marker"
            let-info>
            <span
              class="tw:flex tw:w-12 tw:h-12 tw:items-center tw:justify-center tw:text-white tw:rounded-full"
              [ngClass]="info.iconBg">
              <i [class]="info.icon"></i>
            </span>
          </ng-template>
          <ng-template
            pTemplate="content"
            let-info>
            <div class="tw:pb-12 tw:px-6">
              <div class="tw:text-color tw:text-xl tw:font-medium">{{ info.title }}</div>
              <div class="tw:text-muted-color tw:text-lg">
                {{ info.description }}
              </div>
            </div>
          </ng-template>
        </p-timeline>
      </div>

      <!-- Login Form -->
      <div class="tw:min-w-0 tw:max-w-3xl tw:w-full tw:flex tw:flex-col tw:justify-center tw:p-10">
        <h1 class="tw:text-4xl tw:font-bold tw:text-color">Log in</h1>
        <p class="tw:text-lg tw:text-muted-color tw:mt-3 tw:mb-8">
          Welcome back! Please enter your details
        </p>

        @if (loginForm.controls.type.value === AUTH_TYPE.OTP) {
          @if (isOTPSent() === false) {
            <form
              class="tw:flex tw:flex-col tw:gap-4"
              [formGroup]="loginForm"
              (ngSubmit)="requestEmailOTP()">
              <div>
                <label>UserID or Email</label>

                <p-iconfield>
                  <p-inputicon class="pi pi-envelope" />
                  <input
                    test-id="login-username"
                    pInputText
                    [fluid]="true"
                    placeholder="Enter your username or email"
                    [formControl]="loginForm.controls.username"
                    type="email"
                    pSize="large"
                    class="tw:w-full"
                    [invalid]="
                      loginForm.controls.username.invalid && loginForm.controls.username.touched
                    " />
                </p-iconfield>
                <!-- Required Field Error -->
                @if (loginForm.controls.username.invalid && loginForm.controls.username.touched) {
                  @if (loginForm.controls.username.errors?.required) {
                    <p-message
                      severity="error"
                      variant="simple"
                      [motionOptions]="{ disabled: true }">
                      Username or Email is required
                    </p-message>
                  }
                }
              </div>

              @if (loginError()) {
                <p-message
                  severity="error"
                  icon="pi pi-exclamation-circle"
                  styleClass="tw:mb-4 tw:w-full tw:min-w-0 tw:[contain:inline-size] tw:wrap-anywhere"
                  [motionOptions]="{ disabled: true }">
                  {{ loginError() }}
                </p-message>
              }

              <p-button
                test-id="login-request-verification-code"
                fluid
                [buttonProps]="{ autofocus: false }"
                [label]="requestingOTP() ? 'Requesting…' : 'Request Verification Code'"
                [loading]="requestingOTP()"
                type="submit"
                size="large"
                class="tw:mt-2" />
            </form>
          } @else {
            <div class="tw:mt-3">
              <p>
                A verification code has been sent to
                <b>{{ loginForm.value.username }}</b>
              </p>
              <form
                class="tw:flex tw:flex-col tw:gap-4 tw:mt-3"
                [formGroup]="loginForm"
                (keydown.enter)="signin()"
                (ngSubmit)="signin()">
                <div>
                  <label>Enter 6 digit code</label>
                  <p-inputOtp
                    test-id="login-otp"
                    [formControl]="loginForm.controls.otp"
                    [integerOnly]="true"
                    size="large"
                    [length]="6"
                    [autofocus]="true" />
                </div>
                <div>
                  Didn't get the code?
                  <p-button
                    test-id="login-resend"
                    [buttonProps]="{ autofocus: false }"
                    [label]="requestingOTP() ? 'Sending...' : 'Resend'"
                    [loading]="loading()"
                    [disabled]="requestingOTP()"
                    (click)="requestEmailOTP()"
                    variant="text"
                    styleClass="tw:p-0" />
                </div>

                @if (loginError()) {
                  <p-message
                    severity="error"
                    icon="pi pi-exclamation-circle"
                    styleClass="tw:mb-4 tw:w-full tw:min-w-0 tw:[contain:inline-size] tw:wrap-anywhere"
                    [motionOptions]="{ disabled: true }">
                    {{ loginError() }}
                  </p-message>
                }

                <p-button
                  test-id="login-verify"
                  fluid
                  [buttonProps]="{ autofocus: false }"
                  [label]="loading() === AUTH_TYPE.OTP ? 'Verifying…' : 'Verify'"
                  [loading]="loading() === AUTH_TYPE.OTP"
                  type="submit"
                  size="large"
                  class="tw:mt-3" />
              </form>
            </div>
          }
        } @else {
          <form
            class="tw:flex tw:flex-col tw:gap-4"
            [formGroup]="loginForm"
            (ngSubmit)="signin()">
            <div class="tw:flex tw:flex-col">
              <label>UserID or Email</label>

              <p-iconfield>
                <p-inputicon class="pi pi-user" />
                <input
                  test-id="login-username-2"
                  pInputText
                  [fluid]="true"
                  placeholder="Enter your username or email"
                  [formControl]="loginForm.controls.username"
                  autocomplete="username"
                  class="tw:w-full"
                  pSize="large" />
              </p-iconfield>
              @if (
                loginForm.controls.username.invalid &&
                loginForm.controls.username.touched &&
                loginForm.controls.username.errors?.required
              ) {
                <p-message
                  severity="error"
                  variant="simple"
                  [motionOptions]="{ disabled: true }">
                  Username or Email is required
                </p-message>
              }
            </div>
            <div>
              <label>Password</label>
              <div class="tw:flex">
                <p-iconfield class="tw:flex-1">
                  <p-inputicon class="pi pi-lock" />
                  <input
                    test-id="login-password"
                    pInputText
                    [fluid]="true"
                    placeholder="Enter your password"
                    id="password"
                    [type]="showPassword() === true ? 'text' : 'password'"
                    [formControl]="loginForm.controls.password"
                    autocomplete="current-password"
                    pSize="large"
                    class="tw:w-full tw:rounded-e-none! tw:border-e-0!" />
                </p-iconfield>
                <button
                  test-id="login-toggle-signal"
                  type="button"
                  class="tw:flex tw:w-12 tw:items-center tw:justify-center tw:rounded-e-md tw:border tw:border-(--p-form-field-border-color) tw:text-muted-color tw:cursor-pointer"
                  [attr.aria-label]="showPassword() === true ? 'Hide password' : 'Show password'"
                  (click)="toggleSignal(showPassword)">
                  <i [ngClass]="showPassword() === false ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                </button>
              </div>
              @if (
                loginForm.controls.password.invalid &&
                loginForm.controls.password.touched &&
                loginForm.controls.password.errors?.required
              ) {
                <p-message
                  severity="error"
                  variant="simple"
                  [motionOptions]="{ disabled: true }">
                  Password is required
                </p-message>
              }
            </div>

            @if (loginError()) {
              <p-message
                severity="error"
                icon="pi pi-exclamation-circle"
                styleClass="tw:mb-4 tw:w-full tw:min-w-0 tw:[contain:inline-size] tw:wrap-anywhere"
                [motionOptions]="{ disabled: true }">
                {{ loginError() }}
              </p-message>
            }

            <p-button
              test-id="login-sign-in"
              fluid
              [buttonProps]="{ autofocus: false }"
              [label]="loading() === AUTH_TYPE.PASSWORD ? 'Signing In...' : 'Sign In'"
              [loading]="loading() === AUTH_TYPE.PASSWORD"
              type="submit"
              size="large"
              class="tw:mt-3" />
          </form>
        }
        @if (appConfig().allowedLogins.length > 1) {
          <div class="tw:flex tw:flex-col tw:gap-8 tw:mt-8">
            <div class="tw:flex tw:gap-3 tw:items-center tw:self-center col-8">
              <hr class="tw:border-surface tw:border tw:flex-1" />
              <div>Or Continue With</div>
              <hr class="tw:border-surface tw:border tw:flex-1" />
            </div>
            <div class="tw:flex tw:gap-3 tw:w-full">
              @if (appConfig().allowedLogins | includes: AUTH_TYPE.GOOGLE) {
                <div class="tw:flex-1 tw:min-w-0">
                  <p-button
                    test-id="login-google"
                    fluid
                    class="tw:w-full"
                    styleClass="tw:w-full"
                    icon="pi pi-google"
                    [buttonProps]="{ autofocus: false }"
                    label="Google"
                    [loading]="loading() === AUTH_TYPE.GOOGLE"
                    (click)="oauthLogin(AUTH_TYPE.GOOGLE)"
                    severity="secondary"
                    size="large" />
                </div>
              }
              @if (appConfig().allowedLogins | includes: AUTH_TYPE.MICROSOFT) {
                <div class="tw:flex-1 tw:min-w-0">
                  <p-button
                    test-id="login-microsoft"
                    fluid
                    class="tw:w-full"
                    styleClass="tw:w-full"
                    icon="pi pi-microsoft"
                    [buttonProps]="{ autofocus: false }"
                    label="Microsoft"
                    [loading]="loading() === AUTH_TYPE.MICROSOFT"
                    (click)="oauthLogin(AUTH_TYPE.MICROSOFT)"
                    severity="secondary"
                    size="large" />
                </div>
              }

              @if (appConfig().allowedLogins | includes: AUTH_TYPE.OTP) {
                @if (loginForm.controls.type.value === AUTH_TYPE.OTP) {
                  <div class="tw:flex-1 tw:min-w-0">
                    <p-button
                      test-id="login-password-2"
                      fluid
                      class="tw:w-full"
                      styleClass="tw:w-full"
                      [buttonProps]="{ autofocus: false }"
                      icon="pi pi-key"
                      severity="secondary"
                      size="large"
                      label="Password"
                      (click)="onLoginTypeChange(AUTH_TYPE.PASSWORD)" />
                  </div>
                } @else {
                  <div class="tw:flex-1 tw:min-w-0">
                    <p-button
                      test-id="login-otp-2"
                      fluid
                      class="tw:w-full"
                      styleClass="tw:w-full"
                      [buttonProps]="{ autofocus: false }"
                      icon="pi pi-mobile"
                      severity="secondary"
                      size="large"
                      label="OTP"
                      (click)="onLoginTypeChange(AUTH_TYPE.OTP)" />
                  </div>
                }
              }

              @if (appConfig().allowedLogins | includes: AUTH_TYPE.SAML) {
                <div class="tw:flex-1 tw:min-w-0">
                  <p-button
                    test-id="login-sso"
                    fluid
                    class="tw:w-full"
                    styleClass="tw:w-full"
                    [buttonProps]="{ autofocus: false }"
                    icon="pi pi-shield"
                    severity="secondary"
                    size="large"
                    label="SSO"
                    (click)="samlSSOLogin()" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
